<template>
  <tci-recruit allTitle subtitle="RECRUIT  2024" :title="$t('recruit.mainPage.recruit_new')" :recruits="infos"></tci-recruit>
</template>

<script>
import TciRecruit from "@/components/TciRecruit.vue";

export default {
  name: "Recruit2019",
  components: {
    "tci-recruit": TciRecruit
  },
  data: () => ({
    infos: [{"requests":[
      "计算机、软件、信息工程、数学等理工科专业，2024届毕业生；","掌握JAVA、C语言或C#等基础知识，有相关数据库理论基础知识；","有较强的学习能力、逻辑思维能力；有良好的沟通协调能力，主动合作的团队精神；","性格开朗，热爱软件开发工作，具备较强的责任心、服务及质量意识，能在一定的压力下工作。"
      
    ],"responses":[
      "参与项目的需求分析、设计及相关文档编写工作；","参与项目模块的设计与代码开发；","遵循公司技术标准、代码规范、文档规范；","可以长期全职实习，提供毕业转正（ 不接受兼职或短期实习 ）。"
    ],"practice":[
      "实习期补贴：本科150元-200元/工作日（提供宿舍）。 实习期间为实习生统一购买意外伤害险。",
      "实习期培训：大宇宙集团内实习生统一技术培训，讲师由公司从各个事业部选拔；实际项目培训，由项目组老员工带领技术学习。公司提供免费日语培训，由专业日语老师上课并开展日语培训活动小组。",
      "实习转正待遇：月薪6K~9K，极优秀者9K~11K； 双休、1小时弹性工作制、带薪年假等。"
    ], "position":"苏州、常州"}
    ]
  })
};
</script>
